<div class="top-section">
    <h6 class="heading mb-0">{{ title() }}</h6>
    <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
</div>
<div class="body-section">
    <ng-container *ngFor="let entry of entries(); let i = index;">
        <ng-switch [ngSwitch]="entry.entityType">
            <ng-container *ngSwitchCase="'todo'">
                <app-todo-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                    [show]="show" [entry]="entry" [dateString]="dateString()" [isLabel]="false"></app-todo-block>
            </ng-container>
            <ng-container *ngSwitchCase="'habit'">
                <app-habit-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                    [show]="show" [dateString]="dateString()" [entry]="entry" [isLabel]="false"></app-habit-block>
            </ng-container>
            <ng-container *ngSwitchCase="'journal'">
                <app-journal-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                    [show]="show" [dateString]="dateString()" [entry]="entry" [isLabel]="false"></app-journal-block>
            </ng-container>
            <ng-container *ngSwitchCase="'moneyTracker'">
                <app-money-tracker-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'" [show]="['setup']" [entry]="entry" [isLabel]="false"></app-money-tracker-block>
            </ng-container>
            <ng-container *ngSwitchCase="'calendarIntegration'">
                <app-calendar-event-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                    [entry]="entry" [show]="show" [dateString]="dateString()" [isLabel]="false"></app-calendar-event-block>
            </ng-container>
            <ng-container *ngSwitchCase="'focus'">
                <app-focus-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                    [show]="['setup']" [entry]="entry" [dateString]="dateString()" [isLabel]="false"></app-focus-block>
            </ng-container>
            <ng-container *ngSwitchCase="'note'">
                <app-note-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                    [noteId]="entry.setupId" [isLabel]="false"></app-note-block>
            </ng-container>
        </ng-switch>
    </ng-container>
</div>